<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step orgForm [stepControl]="orgForm">
    <form [formGroup]="orgForm" class="w-full">
      <ng-template matStepLabel> {{ "ORGANIZATIONS" | translate }}</ng-template>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "ORG_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="org_name" />
            <mat-error *ngIf="orgForm.get('org_name')?.hasError('required')">
              {{ "ORG_NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width" *ngIf="organizationId">
          <mat-label>{{ "companyCode" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="company_code" readonly />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "org_type_" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="org_type" required>
              <mat-option value="cooperative">Cooperative (Co-op)</mat-option>
              <mat-option value="corporation">Corporation</mat-option>
              <mat-option value="franchise">Franchise</mat-option>
              <mat-option value="government_organization"
                >Government Organization</mat-option
              >
              <mat-option value="joint_venture">Joint Venture</mat-option>
              <mat-option value="opc">One Person Company (OPC)</mat-option>
              <mat-option value="partnership">Partnership</mat-option>
              <mat-option value="private_limited"
                >Private Limited Company (Pvt Ltd)</mat-option
              >
              <mat-option value="psu"
                >Public Sector Undertaking (PSU)</mat-option
              >
              <mat-option value="public_limited"
                >Public Limited Company (Ltd)</mat-option
              >
              <mat-option value="sole_proprietorship"
                >Sole Proprietorship</mat-option
              >
              <mat-option value="trust">Trust</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('org_type')?.hasError('required')">
              {{ "ORG_TYPE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "DOMAIN" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="domain" [multiple]="true" required>
              <mat-option value="Consultancy">Consultancy</mat-option>
              <mat-option value="Construction">Construction</mat-option>
              <mat-option value="Road">Road</mat-option>
              <mat-option value="Utilities">Utilities</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('domain')?.hasError('required')">
              {{ "DOMAIN_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label>{{ "REG_NO" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="registration_number" />
            <mat-error
              *ngIf="orgForm.get('registration_number')?.hasError('required')"
            >
              {{ "CIN_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "GST_NO" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="gst_number" />
            <mat-error *ngIf="orgForm.get('gst_number')?.hasError('required')">
              {{ "GST_REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="orgForm.get('gst_number')?.hasError('pattern')">
              {{ "GST_PATTERN_INVALID" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "PAN" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="pan_number" />
            <mat-error *ngIf="orgForm.get('pan_number')?.hasError('required')">
              {{ "PAN_REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="orgForm.get('pan_number')?.hasError('pattern')">
              {{ "PAN_PATTERN_INVALID" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label> {{ "line1" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="address_line_1" />
            <mat-error
              *ngIf="orgForm.get('address_line_1')?.hasError('required')"
            >
              {{ "employee.address" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label> {{ "line2" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="address_line_2" />
            <mat-error
              *ngIf="orgForm.get('address_line_2')?.hasError('required')"
            >
              {{ "employee.address" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "COUNTRY" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select
              formControlName="country"
              (selectionChange)="onCountryChange()"
              required
            >
              <mat-option value="">{{
                "SELECT_COUNTRY" | translate
              }}</mat-option>
              <mat-option value="India">India</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('country')?.hasError('required')">
              {{ "COUNTRY_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "STATE" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select
              formControlName="state"
              (selectionChange)="onStateChange()"
              required
            >
              <mat-option value="">{{ "SELECT_STATE" | translate }}</mat-option>

              <mat-option *ngFor="let state of states" [value]="state">{{
                state
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('state')?.hasError('required')">
              {{ "STATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "CITY" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="city" required>
              <mat-option value="">{{ "SELECT_CITY" | translate }}</mat-option>
              <mat-option *ngFor="let city of cities" [value]="city">{{
                city
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('city')?.hasError('required')">
              {{ "CITY_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "POSTAL_CODE" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="postal_code" />
            <mat-error *ngIf="orgForm.get('postal_code')?.hasError('required')">
              {{ "PINCODE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-checkbox formControlName="additional_branch"
            >{{'ADD_BRANCH'| translate}}</mat-checkbox
          >
        </div>
      </div>
      <div class="flex items-center gap-6 flex-wrap" style="margin-bottom: 5px">
        <div class="flex flex-col gap-2">
          <mat-label> {{ "UPLOAD_LOGO" | translate }}</mat-label>
          <button mat-raised-button color="primary" (click)="fileInput.click()">
            {{ "UPLOAD_LOGO" | translate }}
          </button>
          <input
            type="file"
            accept="image/*"
            hidden
            #fileInput
            (change)="onFileSelected($event)"
          />
        </div>

        <div *ngIf="imagePreview" class="rounded border border-gray-300 p-2">
          <img
            src="{{ imagePreview }}"
            alt="Preview"
            class="max-w-[200px] max-h-[150px] object-contain"
          />
        </div>
      </div>
    </form>
    <div class="dashboard-content" style="margin-top: 5px">
      <div class="metrics-overview" (click)="openEmp()">
        <div class="metric-card primary">
          <div class="metric-icon">
            <mat-icon>people</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">{{'employee.add' |translate}}</h3>
            <p class="metric-value">{{ 0 }}</p>
          </div>
        </div>

        <div
          class="metric-card success"
          [routerLink]="['/home/add-excel-import','Employee']"
        >
          <div class="metric-icon">
            <svg
              class="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
              ></path>
            </svg>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">{{'importEmployee' | translate}}</h3>
            <p class="metric-value">{{ 0 }}</p>
          </div>
        </div>

        <div class="metric-card warning">
          <div class="metric-icon">
            <mat-icon>assignment</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">{{'Total_Employee_Counter'|translate}}</h3>
            <p class="metric-value">{{ 0 }}</p>
          </div>
        </div>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="orgEmp == true">
      <div class="bg-white rounded-lg py-3 mb-6">
        <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">
          <div class="col-span-4">
            <mat-label>{{ "employee.full_name" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="full_name"
                [ngClass]="{ 'is-invalid': submitted && f['full_name'].errors }"
              />
              <mat-error
                *ngIf="submitted && f['full_name'].errors?.['required']"
                >{{ "error.full_name_required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label>{{ "employee.contact_email" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="contact_email"
                [ngClass]="{
                  'is-invalid': submitted && f['contact_email'].errors
                }"
              />
              <mat-error
                *ngIf="submitted && f['contact_email'].errors?.['required']"
                >{{ "error.required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>

          <div class="col-span-4">
            <mat-label> {{ "employee.contact_phone" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="contact_phone"
                [ngClass]="{
                  'is-invalid': submitted && f['contact_phone'].errors
                }"
              />
              <mat-error
                *ngIf="submitted && f['contact_phone'].errors?.['required']"
                >{{ "error.required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>

          <div class="col-span-4">
            <mat-label> {{ "employeeId" | translate }}(Company Id)</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="employeeId"
                [ngClass]="{
                  'is-invalid': submitted && f['employeeId'].errors
                }"
              />
              <mat-error
                *ngIf="submitted && f['employeeId'].errors?.['required']"
                >{{ "error.required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label>{{
              "employee.employment_start_date" | translate
            }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                [matDatepicker]="startPicker"
                formControlName="employmentStartDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="startPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-span-4">
            <mat-label> {{ "employee.department" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="department"
                [ngClass]="{
                  'is-invalid': submitted && f['department'].errors
                }"
              />
              <mat-error
                *ngIf="submitted && f['department'].errors?.['required']"
                >{{ "error.required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>

          <div class="col-span-4">
            <mat-label>{{ "employee.designation" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input matInput formControlName="designation" />
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label>Employee ID(Software)</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="employeeNumber"
                [ngClass]="{
                  'is-invalid': submitted && f['employeeNumber'].errors
                }"
              />
              <mat-error
                *ngIf="submitted && f['employeeNumber'].errors?.['required']"
                >{{ "error.required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label>{{ "org_type" | translate }}</mat-label>

            <mat-form-field class="w-full" appearance="outline">
              <mat-select
                formControlName="roleId"
                (selectionChange)="onRoleChange($event.value)"
                required
                [ngClass]="{ 'is-invalid': submitted && f['roleId'].errors }"
              >
                <mat-option value=""
                  >Select {{ "org_type" | translate }}</mat-option
                >
                <mat-option
                  *ngFor="let role of organizations"
                  [value]="role.id"
                  >{{ role.value }}</mat-option
                >
              </mat-select>
              <mat-error *ngIf="submitted && f['roleId'].errors?.['required']">
                {{ "error.role_required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label>
              {{ "employee.role_in_software" | translate }}</mat-label
            >

            <mat-form-field appearance="outline" class="w-full">
              <mat-select
                formControlName="roleInSoftware"
                [ngClass]="{
                  'is-invalid': submitted && f['roleInSoftware'].errors
                }"
              >
                <mat-option value=""
                  >Select
                  {{ "employee.role_in_software" | translate }}</mat-option
                >
                <mat-option
                  *ngFor="let role of designationList"
                  [value]="role"
                  >{{ role }}</mat-option
                >
              </mat-select>
              <mat-error
                *ngIf="submitted && f['roleInSoftware'].errors?.['required']"
                >{{ "error.required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label>{{
              "employee.membership_start_date" | translate
            }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                [matDatepicker]="memStartPicker"
                formControlName="membershipStartDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="memStartPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #memStartPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label>{{
              "employee.membership_end_date" | translate
            }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                [matDatepicker]="memEndPicker"
                formControlName="membershipEndDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="memEndPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #memEndPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-span-4">
            <mat-label> {{ "employee.state" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <mat-select
                formControlName="state"
                (selectionChange)="onStateChange()"
                required
                [ngClass]="{ 'is-invalid': submitted && f['state'].errors }"
              >
                <mat-option value="">Select State</mat-option>

                <mat-option *ngFor="let state of states" [value]="state">{{
                  state
                }}</mat-option>
              </mat-select>
              <mat-error *ngIf="submitted && f['state'].errors?.['required']">{{
                "error.required" | translate
              }}</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label> {{ "employee.city" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <mat-select
                formControlName="city"
                required
                [ngClass]="{ 'is-invalid': submitted && f['city'].errors }"
              >
                <mat-option value="">Select City</mat-option>
                <mat-option *ngFor="let city of cities" [value]="city">{{
                  city
                }}</mat-option>
              </mat-select>
              <mat-error *ngIf="submitted && f['city'].errors?.['required']">{{
                "error.required" | translate
              }}</mat-error>
            </mat-form-field>
          </div>

          <div class="col-span-4">
            <mat-label> {{ "employee.postal_code" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="postalCode"
                [ngClass]="{
                  'is-invalid': submitted && f['postalCode'].errors
                }"
              />
              <mat-error
                *ngIf="submitted && f['postalCode'].errors?.['required']"
                >{{ "error.required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-span-12">
            <mat-label>{{ "employee.address" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                formControlName="address"
                [ngClass]="{ 'is-invalid': submitted && f['address'].errors }"
              />
              <mat-error
                *ngIf="submitted && f['address'].errors?.['required']"
                >{{ "error.required" | translate }}</mat-error
              >
            </mat-form-field>
          </div>

          <div formGroupName="emergencyContact" class="col-span-12">
            <div class="col-span-12">
              <legend>{{ "employee.emergency_contact" | translate }}</legend>
            </div>
            <div
              class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8"
            >
              <div class="col-span-4">
                <mat-label>{{ "employee.ec_name" | translate }}</mat-label>

                <mat-form-field appearance="outline" class="w-full">
                  <input matInput formControlName="name" />
                </mat-form-field>
              </div>

              <div class="col-span-4">
                <mat-label>{{ "employee.ec_mobile" | translate }}</mat-label>

                <mat-form-field appearance="outline" class="w-full">
                  <input matInput formControlName="mobile" />
                </mat-form-field>
              </div>
              <div class="col-span-4">
                <mat-label>{{ "employee.ec_email" | translate }}</mat-label>

                <mat-form-field appearance="outline" class="w-full">
                  <input matInput formControlName="email" />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end mb-2">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              class="w-60"
            >
              {{ "button.submit" | translate }}
            </button>
           
          </div>
        </div>
      </div>
    </form>
    <div class="form-actions" style="float: right">
      <button mat-raised-button color="primary" (click)="addOrg('Emp')" matStepperNext>
        {{ "NEXT" | translate }}
      </button>
    </div>
  </mat-step>
  <mat-step Branch [stepControl]="Branch">
    <ng-template matStepLabel> {{ "BRANCH" | translate }}</ng-template>
    <app-branch-list></app-branch-list>
    <!-- <form [formGroup]="Branch" class="w-full">
      <ng-template matStepLabel> {{ "BRANCH" | translate }}</ng-template>
      <div class="metrics-overview">
        <div
          class="metric-card primary"
          [routerLink]="['/home/organization-add-branch', organizationId]"
        >
          <div class="metric-icon">
            <mat-icon>business</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Add Branch</h3>
          </div>
        </div>

        <div
          class="metric-card success"
          [routerLink]="['/home/add-excel-import','Branch']"
        >
          <div class="metric-icon">
            <svg
              class="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
              ></path>
            </svg>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Import Branch</h3>
          </div>
        </div>
        <div class="metric-card warning">
          <div class="metric-icon">
            <mat-icon>assignment</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Total Branch Counter</h3>
            <p class="metric-value">{{ 0 }}</p>
          </div>
        </div>
      </div>
      <div class="metrics-overview">
        <div class="metric-card primary" [routerLink]="['/home/staff']">
          <div class="metric-icon">
            <mat-icon>people</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Add Branch Employee</h3>
          </div>
        </div>

        <div
          class="metric-card success"
          [routerLink]="['/home/add-excel-import','Employee']"
        >
          <div class="metric-icon">
            <svg
              class="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
              ></path>
            </svg>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Import Branch Employee</h3>
          </div>
        </div>
        <div class="metric-card warning">
          <div class="metric-icon">
            <mat-icon>assignment</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Total Branch Employee Counter</h3>
            <p class="metric-value">{{ 0 }}</p>
          </div>
        </div>
      </div>
    </form> -->
    <div class="form-actions" style="float: right">
      <button mat-raised-button color="primary" matStepperNext>
        {{ "NEXT" | translate }}
      </button>
    </div>
  </mat-step>
  <mat-step material [stepControl]="material">
      <ng-template matStepLabel> {{ "Material" | translate }}</ng-template>
     <app-construction-materials-list></app-construction-materials-list>
    <!-- <form [formGroup]="material" class="w-full">
      <ng-template matStepLabel> {{ "Material" | translate }}</ng-template>
      <div class="metrics-overview">
        <div class="metric-card primary" [routerLink]="['/home/add-material']">
          <div class="metric-icon">
            <mat-icon>business</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Add Material</h3>
          </div>
        </div>

        <div
          class="metric-card success"
          [routerLink]="['/home/add-excel-import','Material']"
        >
          <div class="metric-icon">
            <svg
              class="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
              ></path>
            </svg>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Import Material</h3>
          </div>
        </div>
        <div class="metric-card warning">
          <div class="metric-icon">
            <mat-icon>assignment</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Total Material Counter</h3>
            <p class="metric-value">{{ 0 }}</p>
          </div>
        </div>
      </div>
    </form> -->
    <div class="form-actions" style="float: right">
      <button mat-raised-button color="primary" matStepperNext>
        {{ "NEXT" | translate }}
      </button>
    </div>
  </mat-step>
  <mat-step machine [stepControl]="machine">
    <ng-template matStepLabel> {{ "Machine" | translate }}</ng-template>

    <app-machine-master></app-machine-master>
    <!-- <form [formGroup]="machine" class="w-full">
      <ng-template matStepLabel> {{ "Machine" | translate }}</ng-template>
      <div class="metrics-overview">
        <div class="metric-card primary" [routerLink]="['/home/add-machine']">
          <div class="metric-icon">
            <mat-icon>business</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Add Machine</h3>
          </div>
        </div>

        <div
          class="metric-card success"
          [routerLink]="['/home/add-excel-import','Machine']"
        >
          <div class="metric-icon">
            <svg
              class="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
              ></path>
            </svg>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Import Machine</h3>
          </div>
        </div>
        <div class="metric-card warning">
          <div class="metric-icon">
            <mat-icon>assignment</mat-icon>
          </div>
          <div class="metric-content">
            <h3 class="metric-title">Total Machine Counter</h3>
            <p class="metric-value">{{ 0 }}</p>
          </div>
        </div>
      </div>
    </form> -->
    <div class="form-actions" style="float: right">
      <button mat-raised-button color="primary" (click)="finishWizard()">
        {{ "FINISH" | translate }}
      </button>
    </div>
  </mat-step>

  <!-- Super Admin only: edit the active subscription for this organization. -->
  <mat-step *ngIf="isSuperAdmin && organizationId" [stepControl]="subscriptionForm">
    <ng-template matStepLabel>Subscription</ng-template>

    <mat-card class="w-full mt-2">
      <mat-card-title class="px-4 pt-4 font-semibold">
        Subscription (Super Admin)
      </mat-card-title>
      <mat-card-content class="p-4">

        <div *ngIf="loadingSubscription" class="text-sm text-gray-500 py-3">
          Loading subscription...
        </div>

        <div
          *ngIf="!loadingSubscription && !activeSubscription"
          class="rounded-lg border border-amber-200 bg-amber-50 text-amber-800 px-4 py-3 text-sm"
        >
          No subscription exists for this organization yet.
        </div>

        <form
          *ngIf="!loadingSubscription && activeSubscription"
          [formGroup]="subscriptionForm"
          class="w-full"
        >
          <div class="flex flex-row gap-4 flex-wrap">
            <div class="half-width">
              <mat-label>Subscription ID</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="id" readonly />
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>Subscription class</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="subscription_user_type">
                  <mat-option value="free_user">Free</mat-option>
                  <mat-option value="trial_user">Trial</mat-option>
                  <mat-option value="paid_user">Paid</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>Status</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="status">
                  <mat-option value="active">Active</mat-option>
                  <mat-option value="pending">Pending</mat-option>
                  <mat-option value="suspended">Suspended</mat-option>
                  <mat-option value="cancelled">Cancelled</mat-option>
                  <mat-option value="expired">Expired</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>Payment status</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="payment_status">
                  <mat-option [value]="1">Paid</mat-option>
                  <mat-option [value]="0">Unpaid</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!-- Domain selection (same model as subscription / domain-selection purchase flow) -->
          <div class="w-full mt-4 mb-2">
            <mat-label class="block font-semibold text-gray-800 mb-2">Domains &amp; caps</mat-label>
            <p class="text-sm text-gray-600 mb-3">
              Select domains and set user / project counts per domain. Totals below match
              <code class="text-xs bg-gray-100 px-1 rounded">users_count</code> and
              <code class="text-xs bg-gray-100 px-1 rounded">consultancy_projects</code> on the subscription row.
            </p>
            <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
              <button
                type="button"
                *ngFor="let d of subscriptionDomainCatalog"
                (click)="toggleSubscriptionDomain(d.name)"
                class="border rounded-xl p-3 text-center transition-all text-sm font-medium"
                [ngClass]="isSubscriptionDomainSelected(d.name)
                  ? 'ring-2 ring-blue-500 bg-blue-50 border-blue-300'
                  : 'bg-gray-50 border-gray-200 hover:bg-gray-100'"
              >
                {{ d.name }}
              </button>
            </div>

            <div
              *ngFor="let d of subscriptionDomainCatalog"
              [formGroupName]="d.name"
              class="mt-3 p-4 border border-gray-200 rounded-xl bg-gray-50"
              [class.hidden]="!isSubscriptionDomainSelected(d.name)"
            >
              <h4 class="text-base font-semibold text-blue-800 mb-3">{{ d.name }}</h4>
              <div class="flex flex-row gap-4 flex-wrap">
                <div class="half-width">
                  <mat-label>Users</mat-label>
                  <mat-form-field appearance="outline" class="half-width w-full">
                    <input matInput type="number" min="1" formControlName="users_count" />
                  </mat-form-field>
                </div>
                <div class="half-width">
                  <mat-label>Projects (optional)</mat-label>
                  <mat-form-field appearance="outline" class="half-width w-full">
                    <input
                      matInput
                      type="number"
                      min="1"
                      placeholder="Unlimited if empty"
                      formControlName="projects_count"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="flex flex-wrap gap-6 mt-4 p-3 rounded-lg bg-slate-100 border border-slate-200 text-sm">
              <span><strong>Total user seats:</strong> {{ subscriptionTotalUsers }}</span>
              <span>
                <strong>Total project cap:</strong>
                {{ subscriptionTotalProjects != null ? subscriptionTotalProjects : '— (unlimited)' }}
              </span>
            </div>
          </div>

          <div class="flex flex-row gap-4 flex-wrap">
            <div class="half-width">
              <mat-label>Duration (months)</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput type="number" min="1" formControlName="duration" />
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>Total amount</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput type="number" min="0" formControlName="total_amount" />
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4 flex-wrap w-full">
            <div class="w-full max-w-xl">
              <mat-label>Update note (optional)</mat-label>
              <mat-form-field appearance="outline" class="w-full">
                <input
                  matInput
                  formControlName="update_reason"
                  placeholder="Reason for this change (stored on subscription metadata)"
                />
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4 flex-wrap">
            <div class="half-width">
              <mat-label>Membership start date</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput [matDatepicker]="subStart" formControlName="membership_start_date" />
                <mat-datepicker-toggle matSuffix [for]="subStart"></mat-datepicker-toggle>
                <mat-datepicker #subStart></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>Membership end date</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput [matDatepicker]="subEnd" formControlName="membership_end_date" />
                <mat-datepicker-toggle matSuffix [for]="subEnd"></mat-datepicker-toggle>
                <mat-datepicker #subEnd></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="form-actions flex justify-end gap-3 pt-2">
            <button
              mat-button
              type="button"
              (click)="loadSubscription()"
              [disabled]="loadingSubscription || savingSubscription"
            >
              Reset
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="saveSubscription()"
              [disabled]="savingSubscription"
            >
              {{ savingSubscription ? 'Saving...' : 'Save subscription' }}
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-step>
</mat-horizontal-stepper>
